import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ContextMenuElement } from "@base/classes/BaseClasses";
import { BaseComponent } from "@base/component/BaseComponent";
import { ServiceBagService } from "@base/component/ServiceBag";
import { BaseState } from "@base/entities/BaseEntities";
import { BottomSheetService } from "@core/framework/bottom-sheet.service";
import { ScreenService } from "@core/framework/screen.service";
import { DemoButtonsComponent } from "@ui/demo/components/buttons/demo-buttons.component";
import { Subscription } from "rxjs";

class State extends BaseState {
    ListItems: any[] = [];
    ContextMenu: ContextMenuElement[] = [];
}

@Component({
    selector: 'app-demo-bottom-sheets',
    templateUrl: './demo-bottom-sheets.component.html',
    styleUrls: ['../../styles/demo-styles.scss']
})
export class DemoBottomSheetsComponent extends BaseComponent<State> {

    @ViewChild('template') template: TemplateRef<any>;

    private bottomListSubscription: Subscription;
    
    constructor(A: ServiceBagService, public screen: ScreenService, private bottomSheetService: BottomSheetService) {
        super(A, 'DemoBottomSheetsComponent', State);
    }

    protected override OnInitComponent() {
        this.State.ListItems = this.GetListItems();
        this.State.ContextMenu = this.GetContextMenu();
    }
    
    protected override OnDestroyComponent() {
        super.OnDestroyComponent();
        
        this.bottomListSubscription?.unsubscribe();
    }
    
    public OnShowComponentClicked() {
        this.bottomSheetService.ShowComponent(DemoButtonsComponent, "Component Example");
    }
    
    public OnShowTemplateClicked() {
        this.bottomSheetService.ShowTemplate(this.template, "Template Example");
    }
    
    public OnShowListClicked() {
        this.bottomListSubscription = this.bottomSheetService
            .ShowList('Items', this.State.ListItems, false)
            .subscribe((result) => console.log(result));
    }

    public OnShowContextMenuClicked() {
        this.bottomSheetService.ShowContextMenu('Context Menu Example', this.State.ContextMenu);
    }
    
    public GetContextMenu() : ContextMenuElement[] {
        return [
            {
                text: 'Add',
                icon: 'add',
                onClick: () => console.log('Context Menu - add button clicked.')
            },
            {
                text: 'Edit',
                icon: 'edit',
                onClick: () => console.log('Context Menu - edit button clicked.')
            }
        ]
    }
    
    public GetListItems() {
        return [
            {
                EntryID: 1,
                Name: 'Clock',
                Icon: 'mdi mdi-clock-outline'
            },
            {
                EntryID: 2,
                Name: 'Map',
                Icon: 'mdi mdi-map-outline'
            },
            {
                EntryID: 3,
                Name: 'Agenda',
                Icon: 'mdi mdi-view-agenda-outline'
            }
        ];
    }
}
